import type { Credit } from "@nlc/shared-types";

import { formatCurrency } from "../../../utils/format-currency";
import { CREDIT_REASON_LABELS } from "./credit-reason";

export function formatCreditReason({
  note,
  reason,
}: Pick<Credit, "note" | "reason">): string {
  return note || CREDIT_REASON_LABELS[reason];
}

export function formatCreditAmount(amount: string, currency: string): string {
  if (Number(amount) === 0) return "-";

  return formatCurrency(amount, currency);
}

export function formatCreditIssuer({
  issuedBy,
}: Pick<Credit, "issuedBy">): string {
  return issuedBy ?? "System";
}

export function isCreditUsed({
  remaining,
}: Pick<Credit, "remaining">): boolean {
  return Number(remaining) === 0;
}
